import React, { useState,useContext } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./ReactCalender.css"; // Import the default styling

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";


const MyCalendar = () => {
  const { curerntYear,currentMonth, monthNames,selectedDate,setSelectedDate } = useContext(MyContext);

  // Set a default date for the calendar (e.g., today's date)
  const [date, setDate] = useState(new Date());

  // Handle date change
  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    const date = new Date(selectedDate);
    const year = date.getFullYear();
    const month = date.getMonth();
    console.log(year, monthNames[month]);

    setSelectedDate({
      month: `${monthNames[month]}`,
      year: year,
      day: date.getDate(),
    });//set the selected date

    
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Calendar
        onChange={handleDateChange}
        value={date}
        // Disable the input field by not providing it; only the calendar is visible
        tileDisabled={() => false} // Optional: if you want to disable specific tiles, customize this
      />
    </div>
  );
};

export default MyCalendar;
